import { Box, createStyles, makeStyles } from "@material-ui/core";
import React, { FC } from "react";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      height: "max-content",
      flexWrap: "wrap",
    },
  })
);

const RightButtonArea: FC = ({ children }) => {
  const cssClasses = useStyles({});
  return <Box className={cssClasses.root}>{children}</Box>;
};

export default RightButtonArea;
